import { useState } from 'react';
import * as _ from 'underscore';
import { Messages } from '../../../../../codegen/Localize';
import { SiteSwitchService } from '../../../../../ts/services/SiteSwitchService';
import { SiteIdValidRegExp } from '../../../../controllers/SiteSettingsForServerAdminFormCtrl';
import { SiteSettingsForServerAdminProps } from '../../ReactSiteSettingsForServerAdmin';
import { SiteNameAndIdSectionProps } from './SiteNameAndIdSection';

export function calculateUrlFromUrlName(urlName: string) {
  return () => window.location.href.replace(window.location.hash.substring(1), '') +
    SiteSwitchService.getSitePathFragment(urlName);
}

export const calculateUrlNameFromSiteName = (siteName: string) =>
  _.isString(siteName) ? siteName.replace(SiteIdValidRegExp.InvalidFind, '') : '';

export function useShouldCopySiteNameToUrl(props: SiteNameAndIdSectionProps) {
  const [shouldCopySiteNameToUrl] = useState(!props.isDefaultSite &&
    calculateUrlNameFromSiteName(props.settings.name) === props.settings.urlName);

  return shouldCopySiteNameToUrl;
}

export const SiteIdValidator = (v: string) => SiteIdValidRegExp.InvalidTest.test(v)
  ? undefined
  : Messages.siteIDInvalid();
